import { useContext } from 'react'
import { ProductPopupContext } from 'src/contexts/ProductPopupContext'

// ----------------------------------------------------------------------

export default function useProductPopup() {
  return useContext(ProductPopupContext)
}
